import axios from "axios";
const instance = axios.create({ baseURL: "/proxy/public" });

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    const asanLoginIdToken = sessionStorage.getItem("asanLoginIdToken");
    if (asanLoginIdToken) {
      config.headers["dlidt"] = asanLoginIdToken;
    }
    const asanLoginToken = sessionStorage.getItem("asanLoginToken");
    if (asanLoginToken) {
      config.headers["dlt"] = asanLoginToken;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// instance.interceptors.request.use(
//   async (config) => {
//     const token = sessionStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     } else {
//       try {
//         const lastDLCode = localStorage.getItem("lastDLCode");
//         const lastDLState = localStorage.getItem("lastDLState");
//         const tokenPayload = {
//           lastDLCode: lastDLCode || Date.now().toString(),
//           lastDLState: lastDLState || Date.now().toString(),
//         };
//         const tokenFromApi = await generateTokenFromData(tokenPayload);
//         if (tokenFromApi) {
//           config.headers["Authorization"] = `Bearer ${tokenFromApi}`;
//         }
//       } catch (error) {
//         console.error("Error generating token from API:", error);
//       }
//     }

//     return config;
//   },
//   (err) => {
//     return Promise.reject(err);
//   }
// );

export default instance;
